/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Sovereign_DescriptionInputs */

const en_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite agency features and custom domains`)
};

const es_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características de agencia de élite y dominios personalizados`)
};

const fr_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités d'agence d'élite et domaines personnalisés`)
};

const de_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite-Agenturfunktionen und eigene Domains`)
};

const ja_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エリート向けエージェンシー機能とカスタムドメイン`)
};

const zh_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尊享代理级功能与自定义域名`)
};

const ar_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميزات وكالة النخبة ونطاقات مخصصة`)
};

const id_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur agensi elit dan domain kustom`)
};

const it_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità d'agenzia d'élite e domini personalizzati`)
};

const ru_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элитные агентские функции и собственные домены`)
};

const pt_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos de agência de elite e domínios personalizados`)
};

const ko_tier_sovereign_description = /** @type {(inputs: Tier_Sovereign_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`엘리트 에이전시 기능 및 맞춤형 도메인 제공`)
};

/**
* | output |
* | --- |
* | "Elite agency features and custom domains" |
*
* @param {Tier_Sovereign_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_sovereign_description = /** @type {((inputs?: Tier_Sovereign_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Sovereign_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_sovereign_description(inputs)
	if (locale === "es") return es_tier_sovereign_description(inputs)
	if (locale === "fr") return fr_tier_sovereign_description(inputs)
	if (locale === "de") return de_tier_sovereign_description(inputs)
	if (locale === "ja") return ja_tier_sovereign_description(inputs)
	if (locale === "zh") return zh_tier_sovereign_description(inputs)
	if (locale === "ar") return ar_tier_sovereign_description(inputs)
	if (locale === "id") return id_tier_sovereign_description(inputs)
	if (locale === "it") return it_tier_sovereign_description(inputs)
	if (locale === "ru") return ru_tier_sovereign_description(inputs)
	if (locale === "pt") return pt_tier_sovereign_description(inputs)
	return ko_tier_sovereign_description(inputs)
});